import { Validators } from '@angular/forms';

export class QuoteDetailsModel {
  purpose = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  product = {
    value: null,
    validation: Validators.compose([])
  };
  allowCards = {
    value: false,
    validation: Validators.compose([])
  };

  productName = {
    value: null,
    validation: Validators.compose([])
  };
  purposeName = {
    value: null,
    validation: Validators.compose([])
  };
  vehicle = {
    value: {},
    validation: Validators.compose([])
  };
  variant = {
    value: null,
    validation: Validators.compose([])
  };
  odometer = {
    value: null,
    validation: Validators.compose([Validators.pattern('[0-9]*')])
  };
  specs = {
    value: {},
    validation: Validators.compose([])
  };
  isGreen = {
    value: false,
    validation: Validators.compose([])
  };
  vin = {
    value: null,
    validation: Validators.compose([])
  };
  description = {
    value: null,
    validation: Validators.compose([])
  };
  purchaseRefinanceAmount = {
    value: 0.00,
    validation: Validators.compose([
      Validators.required,
      Validators.min(1),
    ])
  };
  depositTradeAmount = {
    value: 0.00,
    validation: Validators.compose([
      Validators.required
    ])
  };
  subTotal = {
    value: 0.00,
    validation: Validators.compose([
      Validators.required
    ])
  };
  originationFeeCheck = {
    value: false,
    validation: Validators.compose([])
  };
  originationFee = {
    value: 0.00,
    validation: Validators.compose([
      Validators.min(1),
      Validators.max(1210)
    ])
  };
  applicationFee = {
    value: 400.00,
    validation: Validators.compose([])
  };
  subtotalWithFees = {
    value: 0.00,
    validation: Validators.compose([])
  };
  brokerageFeeCapitalizedCheck = {
    value: null,
    validation: Validators.compose([])
  };
  brokerageFeeCheck = {
    value: false,
    validation: Validators.compose([])
  };
  brokerageFeePercentage = {
    value: 0.00,
    validation: Validators.compose([
      Validators.max(4.4)
    ])
  };
  brokerageFee = {
    value: 0.00,
    validation: Validators.compose([])
  };
  totalLoanAmount = {
    value: 0.00,
    validation: Validators.compose([
      Validators.required
    ])
  };

  // insurance array
  insurances = {
    value: [],
    validation: Validators.compose([])
  };

  repaymentFrequency = {
    value: null,
    validation: Validators.compose([
        Validators.required
    ])
  };
  loanTermId = {
    value: null,
    validation: Validators.compose([
        Validators.required
    ])
  };
  loanTerm = {
    value: null,
    validation: Validators.compose([])
  };
  securityType = {
    value: null,
    validation: Validators.compose([])
  };
  balloonAmount = {
    value: 0.00,
    validation: Validators.compose([
        Validators.required
    ])
  };
  balloonPercentage = {
    value: null,
    validation: Validators.compose([
        Validators.required
    ])
  };
}

export class InvidualInsuranceModel {
  insuranceId = {
    value: null,
    validation: Validators.compose([])
  };
  insuranceAmount = {
    value: 0.00,
    validation: Validators.compose([])
  };
}
